<template>
  <div class="havya">
    <menuBox :step="1"></menuBox>
    <div class="havya-box">
      <div class="banner-text">
        <div class="title">HAVYA SYSTEMS LLP</div>
        <div class="text">Your travel concierge</div>
        <div class="btn" @click="step">learn more</div>
      </div>
      <div class="population">
        <div class="item">
          <img src="../assets/population1.png" alt="">
          <div>
            <p>Population:</p>
            <span>140.0M</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/population2.png" alt="">
          <div>
            <p>Territory:</p>
            <span>298.0km²</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/population3.png" alt="">
          <div>
            <p>AVG Price:</p>
            <span>$425.600</span>
          </div>
        </div>
      </div>
    </div>
    <div class="visit-box">
      <div class="title">Understand the meaning of travel</div>
      <div class="text">Travel allows you to experience the beauty of life</div>
      <div class="item">
        <img src="../assets/visit1.png" class="visitImg" alt="">
        <div class="itemBox">
          <div class="top">
            <p>Expand horizons and enrich experience</p>
            <!-- <span>Go There</span> -->
          </div>
          <div class="itemTitle">
            Travel is not only the process of pursuing scenery, but also the continuous expansion of personal vision and
            knowledge. It allows us to experience the charm of different cultures, learn history, and experience local
            life, thereby broadening our knowledge and enriching our life experiences.
          </div>
          <div class="listBox">
            <div class="list">
              <img src="../assets/visit4.png" alt="">
              <span>2K+ users</span>
            </div>
            <div class="list">
              <img src="../assets/visit5.png" alt="">
              <span>4,000 USD per capita</span>
            </div>
            <!-- <div class="list">
              <img src="../assets/visit6.png" alt="">
              <span>8.66 Mil People</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/visit2.png" class="visitImg" alt="">
        <div class="itemBox">
          <div class="top">
            <p>Self-exploration and challenging limits</p>
            <!-- <span>Go There</span> -->
          </div>
          <div class="itemTitle">
            Traveling allows people to step out of the comfort zone of daily life and face new environments and
            challenges. Whether it is climbing a peak, diving deep into the sea, or simply traveling alone, every trip is
            an exploration and challenge of ourselves, helping us better understand ourselves, exercise our will, and
            improve our ability to adapt to new environments.
          </div>
          <div class="listBox">
            <div class="list">
              <img src="../assets/visit4.png" alt="">
              <span>4K+ users</span>
            </div>
            <div class="list">
              <img src="../assets/visit5.png" alt="">
              <span>average USD 800 per capita</span>
            </div>
            <!-- <div class="list">
              <img src="../assets/visit6.png" alt="">
              <span>8.66 Mil People</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/visit3.png" class="visitImg" alt="">
        <div class="itemBox">
          <div class="top">
            <p>Soul Restoration Station</p>
            <!-- <span>Go There</span> -->
          </div>
          <div class="itemTitle">
            In the fast-paced modern life, traveling has become a way to escape from daily life and repair the body and
            mind. It provides an opportunity to take a break from work stress, family responsibilities, and relax
            physically and mentally. The natural beauty and tranquil environment can heal the soul and return to inner
            peace and purity.
          </div>
          <div class="listBox">
            <div class="list">
              <img src="../assets/visit4.png" alt="">
              <span>100+ users</span>
            </div>
            <div class="list">
              <img src="../assets/visit5.png" alt="">
              <span>6,000 US dollars per capita</span>
            </div>
            <!-- <div class="list">
              <img src="../assets/visit6.png" alt="">
              <span>8.66 Mil People</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "aboutUs" });
    }
  },
};
</script>

<style lang="less" scoped>
.havya-box {
  background-image: url(../assets/home.png);
  height: 700px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    padding-top: 150px;
    text-align: center;

    .title {
      margin-bottom: 10px;
      font-size: 20px;
      font-family: ArialMT;
      color: #FFFFFF;
    }

    .text {
      margin-bottom: 10px;
      font-size: 72px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 101px;
    }

    .btn {
      cursor: pointer;
      display: inline-block;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #00B3C0;
      padding: 16px 38px;
      border-radius: 28px;
      border: 1px solid #00B3C0;
    }
  }

  .population {
    width: 1200px;
    padding: 30px 0;
    position: absolute;
    bottom: 120px;
    left: 360px;
    display: flex;
    justify-content: space-around;
    background: #FFFFFF;
    border-radius: 61px;

    .item {
      display: flex;
      align-items: center;
    }

    img {
      margin-right: 18px;
      width: 62px;
      height: 62px;
    }

    p {
      font-size: 16px;
      font-family: ArialMT;
      color: #999999;
    }

    span {
      font-size: 20px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #00B3C0;
    }
  }
}

.visit-box {
  padding: 110px 360px 50px;
  box-sizing: border-box;

  .title {
    margin-bottom: 26px;
    font-size: 32px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
  }

  .text {
    margin-bottom: 60px;
    font-size: 20px;
    font-family: ArialMT;
    color: #999999;
  }

  .item {
    display: flex;
    margin-bottom: 60px;

    .visitImg {
      margin-right: 40px;
      width: 560px;
      height: 315px;
    }

    .itemBox {


      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        p {
          font-size: 20px;
          font-family: Arial, Arial;
          font-weight: 900;
          color: #333333;
          line-height: 28px;
        }

        span {
          padding: 15px 38px;
          background: #00B3C0;
          border-radius: 28px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #FFFFFF;
        }
      }

      .itemTitle {
        margin-bottom: 64px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 32px;
      }

      .listBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 17px 0;
        border-bottom: 1px solid #DAE3E9;
        border-top: 1px solid #DAE3E9;

        .list {
          display: flex;
          align-items: center;

          img {
            margin-right: 4px;
            width: 20px;
            height: 20px;
          }

          span {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
